<template>
  <div class="page" :class="(mapPation)?('map-page'):('')" :name='name+"_"+pagesize'>
    <el-pagination v-if="sizes" :layout="total>10 ?'total,prev, pager, next' : 'total,prev, pager, next'" :pager-count="5" @size-change="handleSizeChange" :current-page.sync="nowPage" :page-size="nowPagesize" @current-change="changePage" :total="total">
    </el-pagination>
    <el-pagination v-else :layout="total>10 ?'total,sizes,prev, pager, next' : 'total,prev, pager, next'" :pager-count="5" @size-change="handleSizeChange" :page-sizes="[10, 20, 50]" :current-page.sync="nowPage" :page-size="nowPagesize" @current-change="changePage" :total="total">
    </el-pagination>
    <div  id="jumpPage" @keyup.enter="jumpPages">
      <el-input-number v-model="jumpPage" :controls="false" :min="1" :class="(mapPation)?('map-jump-num'):('')"></el-input-number>
      <span class="jump" @click="jumpPages" :name="name+'_jump'" :id="name+'_jump'">跳转</span>
    </div>
  </div>
</template>
<script>
  export default {
    props:['name','total','page','pagesize','sizes','mapPation'],
    data() {
      return {
        nowPage:1,
        nowPagesize:20,
        jumpPage:1,
      };
    },
    computed:{

    },
    watch:{
      page:function(val){
        if(val){
          this.nowPage = val;
          if(this.jumpPage!=val){
            this.jumpPage = val;
          }
        }
      },
      pagesize:function(val){
        if(val){
          this.nowPagesize = this.pagesize;
        }
      },
    },
    methods:{
      handleSizeChange(size){
        if(size!=this.nowPagesize){
          this.$emit('handleSizeChange',size);
        }
      },
      changePage(page){
        this.$emit('changePage',page);
      },
      jumpPages(){
        if(isNaN( parseInt(this.jumpPage))){
          this.jumpPage =  this.nowPage;
          return;
        }
        let max = Math.ceil(this.total/this.nowPagesize);
        this.jumpPage = (this.jumpPage>max)?max: this.jumpPage;
        if( this.jumpPage!=this.nowPage){
          this.nowPage =  this.jumpPage;
          this.$emit('changePage', this.nowPage);
        }
        window.sa.quick('trackHeatMap',document.querySelector('.jump'));//第二个参数是发生事件的dom元素
      },
    },
    mounted(){
      this.nowPage = this.page;
      this.nowPagesize = this.pagesize;
    }
  };
</script>
<style lang="scss" scoped>
#jumpPage{
  position: relative;
  top: -4px;
  padding-right: 45px;
  .jump{
    position: absolute;
    right: 0;
    top:6px;
    display:inline-block;
    font-size: 14px;
    color: #555;
    cursor: pointer;
    border: 1px solid #dcdfe6;
    height: 28px;
    line-height: 28px;
    padding: 0 8px;
    border-left: 0;
    &:hover{
      color: var(--theme-color);
    }
  }
}
.page{
  display: flex;
  justify-content:flex-end;
}
.map-page{
  padding: 14px 20px 14px 20px;
  margin: 0;
  #jumpPage{
    top: -3px;
    .jump{
      font-size: 12px;
      // border-left: 1px solid #dcdfe6;
      right: 3px;
      top: 5px;
    }
  }
}
</style>
<style>
.result .page.map-page{
  height: 56px;
  position: fixed;
  bottom:0;
  background: #fff;
}
</style>







// WEBPACK FOOTER //
// src/components/global/customPagination.vue